module.exports = __webpack_public_path__ + "img/personnel_access_feature_04.d0d09b2e.jpg";